import styled from "styled-components";

export const MaxLBox = styled.div`
  max-width: 1440px;
  margin: 0 auto;
`;

export const MidLBox = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  @media (min-width: 1441px) {
    max-width: 1400px;
  }
`;

export const MinLBox = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  @media (min-width: 1441px) {
    max-width: 1200px;
  }
`;
